// extracted by mini-css-extract-plugin
export var clients = "styles-module--clients--0d88a";
export var reviews = "styles-module--reviews--a8443";
export var stars = "styles-module--stars--3d998";